// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1UeYK","errorLogs":"styles_errorLogs__MlBBS"};